import { useState } from "react";
import { Button, Form, Input } from "antd";
import { useNavigate } from "react-router";

import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import Icons from "scripts/icons";
import { ObjectNumbersToEnglish } from "scripts/helpers";

const Component = () => {
	const initialState = {};
	const [state, setState] = useState(initialState);
	const { submitting } = state;
	const [form] = Form.useForm();
	const navigate = useNavigate();

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				values = ObjectNumbersToEnglish(values);

				API.auth
					.status(values)
					.then(({ shouldRegister }) => {
						navigate({
							pathname: shouldRegister ? "/auth/verify" : "/auth/login",
							search: `?mobile=${values.phone}`,
						});
					})
					.catch(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	return (
		<>
			<h1 className="heading">{Resources.welcome}</h1>
			<span className="text">{Resources.statusText}</span>
			<Form form={form} layout="vertical" requiredMark={false}>
				<Form.Item name="phone" label={Resources.mobile} rules={Rules.mobile}>
					<Input
						type="tel"
						size="large"
						placeholder={Resources.mobile}
						suffix={<Icons.Calling />}
					/>
				</Form.Item>
			</Form>
			<div className="actions">
				<Button
					className="btn-default"
					size="large"
					disabled={submitting}
					onClick={() => navigate("/", { replace: true })}
				>
					{Resources.cancel}
				</Button>
				<Button
					type="primary"
					size="large"
					loading={submitting}
					onClick={handleSubmit}
				>
					{`${Resources.confirm} ${Resources.and} ${Resources.continue}`}
				</Button>
			</div>
		</>
	);
};

export default Component;
